var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg010Gloves = function Svg010Gloves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.006 451h270v61h-270zM178.006 380.995V421h120v-90c0-33.091-26.909-60-60-60-18.765 0-36.709-8.965-48.003-23.994l-45.015-60.015c-14.824-19.836-43.019-23.954-62.974-8.979C62.226 192.8 57.998 221.002 73.005 241z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M448.006 135c0-74.559-60.441-135-135-135s-135 60.441-135 135v46.022l35.991 47.981c5.64 7.5 14.619 11.997 24.009 11.997 49.629 0 90 40.371 90 90v90h120z"
  })));
};
export default Svg010Gloves;